import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const VariableValue = ({variable, value}) => { 
    return (
        <div className="variable-value">
          {value}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      value: props.variable.effect ? props.variable.effect.value :
          props.variable.message
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VariableValue);
